// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  box-shadow: none;
}
ion-header .main-header {
  position: relative;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 28px;
  border-bottom: 0.5px solid #a3a3a3;
}
ion-header .main-header .logo {
  height: 70px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
ion-header .main-header .main-right {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}
ion-header .main-header .main-right .order-chip {
  display: none;
  justify-content: center;
  align-items: center;
  height: 30px;
  margin-right: 12px;
  margin-left: 10px;
  position: relative;
}
@media (min-width: 991px) {
  ion-header .main-header .main-right .order-chip {
    display: flex;
  }
}
ion-header .main-header .main-right .order-chip__busket {
  height: 100%;
  --icon-color: #1e1e1c;
  height: 30px;
  width: 30px;
}
ion-header .main-header .main-right .order-chip__quantity {
  position: absolute;
  top: -8px;
  right: -2px;
  height: 20px;
  width: 20px;
  border-radius: 50px;
  background-color: #ea4949;
  display: flex;
  justify-content: center;
  align-items: center;
}
ion-header .main-header .main-right .order-chip__quantity .number {
  font-family: AppFontSemiBold;
  font-size: 14px;
  color: #fff;
}

.container-all .wrapper-left {
  display: flex;
  justify-content: center;
  align-self: center;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #faf7f6;
}
.container-all .wrapper-left ion-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.container-all.wrapper-info {
  overflow: auto;
  padding: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.container-all.wrapper-info .header-title {
  margin-top: 50px;
  text-align: center;
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
  text-transform: capitalize;
}
.container-all.wrapper-info .title-section {
  width: 100%;
}
.container-all.wrapper-info .title-section h3 {
  text-align: center;
  color: var(--color-black);
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
}
.container-all.wrapper-info ion-card {
  margin: 20px 0px;
  padding: 12px;
  text-align: initial;
  border: none;
  box-shadow: none;
  background: transparent;
  --color: var(--color-black);
  --preorder-type-chip-border-color: var(--ion-color-primary);
  overflow: auto;
  word-break: break-word;
}
.container-all.wrapper-info ion-card ion-card-header {
  background: white;
  color: var(--color-black);
  padding: 0;
  padding-bottom: 8px;
  border-bottom: 0.3px solid rgba(126, 167, 105, 0.4509803922);
}
.container-all.wrapper-info ion-card ion-card-header .separator {
  margin-block: 20px;
}
.container-all.wrapper-info ion-card ion-card-content {
  border-top: 0.3px solid rgba(126, 167, 105, 0.4509803922);
  padding: 10px 0px 0px 0px;
  line-break: auto !important;
}
.container-all.wrapper-info ion-card ion-card-content:first-of-type {
  border: none;
}
.container-all.wrapper-info ion-card ion-card-content .padding-card {
  padding: 10px;
}
.container-all.wrapper-info ion-card ion-card-title {
  font-family: AppFontBold, sans-serif;
  color: var(--color-black);
  font-size: 18px;
}
.container-all.wrapper-info ion-card .icon-edit {
  zoom: 1.3;
}
.container-all.wrapper-info ion-card ion-col {
  padding: 5px 0px;
  color: var(--color-black);
  font-size: 14px;
}
.container-all.wrapper-info ion-card .left-col {
  text-align: left;
  font-family: AppFontBold, sans-serif;
}
.container-all.wrapper-info ion-card .right-col {
  font-family: AppFont, sans-serif;
  text-align: right;
}
.container-all.wrapper-info ion-card .right-col.bold {
  font-family: AppFontBold, sans-serif;
}

.quantity {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: 24px;
  border: 0.5px solid #262626;
  border-radius: 50px;
  margin-right: 10px;
  font-family: AppFont;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: baseline;
}

.price-subtitle ion-col {
  font-family: AppFont !important;
}

.header-sliders {
  display: flex;
  justify-content: space-between;
  padding: 20px 0px;
}
.header-sliders .step {
  width: 33%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.header-sliders .step .line {
  width: 100%;
  height: 5px;
  background-color: #d9d9d9;
}
.header-sliders .step .line.selected {
  background-color: var(--ion-color-primary);
  animation: pulse 2s infinite;
}
.header-sliders .step p {
  padding-top: 10px;
}

@keyframes pulse {
  0%, 100% {
    background-color: var(--ion-color-primary);
    opacity: 1;
  }
  50% {
    background-color: var(--ion-color-primary);
    opacity: 0.5;
  }
}
.delivery-steps {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.delivery-steps__item {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}
.delivery-steps__item ion-icon {
  width: 100px;
  height: 100px;
}
.delivery-steps__item p,
.delivery-steps__item h3,
.delivery-steps__item h5 {
  color: var(--ion-color-secondary);
  padding: 10px;
}
.delivery-steps__item p {
  font-family: AppFont;
  padding: 0px;
}
.delivery-steps__item h3,
.delivery-steps__item h5 {
  font-family: AppFontBold, sans-serif;
}
.delivery-steps__item p {
  font-size: 12px;
}
.delivery-steps__item h5 {
  font-size: 16px;
}
.delivery-steps__item h3 {
  font-size: 18px;
  text-transform: uppercase;
  text-align: center;
}
.delivery-steps .map-block {
  min-height: 0px;
  opacity: 0;
  z-index: -1;
  max-height: 0px;
  position: relative;
}
.delivery-steps .map-block .show-time {
  position: absolute;
  top: 50px;
  background: white;
  padding: 10px 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-secondary);
}
.delivery-steps .map-block .status-show {
  position: absolute;
  bottom: 50px;
  background: white;
  padding: 10px 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-secondary);
}
.delivery-steps .map-block.hide-item {
  min-height: 400px;
  max-height: 400px;
  opacity: 1;
  z-index: 1;
}

.map-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 30px;
  overflow: hidden;
}

.map-frame {
  border: 2px solid black;
  height: 100%;
}

#map-item {
  height: 100%;
}

ion-footer {
  box-shadow: none;
}
ion-footer ion-button {
  width: 80%;
  margin: 0 auto;
  --border-radius: 50px;
  font-family: AppFontSemiBold;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/payment-success.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,gBAAA;AADD;AAGC;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kCAAA;AADF;AAGE;EACC,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AADH;AAIE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAFH;AAIG;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;ACjCE;ED4BC;IAUE,aAAA;EADH;AACF;AAGI;EACC,YAAA;EAEA,qBAAA;EACA,YAAA;EACA,WAAA;AAFL;AAQI;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AANL;AAQK;EACC,4BAAA;EACA,eAAA;EACA,WAAA;AANN;;AAeC;EACC,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAZF;AAaE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAXH;AAiBC;EACC,cAAA;EACA,aAAA;EAEA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;AAhBF;AAiBE;EACC,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,oCAAA;EACA,0BAAA;AAfH;AAiBE;EACC,WAAA;AAfH;AAgBG;EACC,kBAAA;EACA,yBAAA;EAEA,oCAAA;EACA,eAAA;AAfJ;AAkBE;EACC,gBAAA;EACA,aAAA;EAEA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2DAAA;EACA,cAAA;EACA,sBAAA;AAjBH;AAkBG;EACC,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,mBAAA;EAIA,4DAAA;AAnBJ;AAgBI;EACC,kBAAA;AAdL;AAkBG;EACC,yDAAA;EAEA,yBAAA;EACA,2BAAA;AAjBJ;AAkBI;EACC,YAAA;AAhBL;AAkBI;EACC,aAAA;AAhBL;AAmBG;EACC,oCAAA;EACA,yBAAA;EACA,eAAA;AAjBJ;AAmBG;EACC,SAAA;AAjBJ;AAmBG;EACC,gBAAA;EACA,yBAAA;EAEA,eAAA;AAlBJ;AAoBG;EACC,gBAAA;EACA,oCAAA;AAlBJ;AAqBG;EACC,gCAAA;EACA,iBAAA;AAnBJ;AAoBI;EACC,oCAAA;AAlBL;;AAyBA;EACC,oBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;AAxBD;;AA4BC;EACC,+BAAA;AAzBF;;AA6BA;EACC,aAAA;EACA,8BAAA;EACA,iBAAA;AA1BD;AA2BC;EACC,UAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAzBF;AA0BE;EACC,WAAA;EACA,WAAA;EACA,yBAAA;AAxBH;AAyBG;EACC,0CAAA;EAEA,4BAAA;AAxBJ;AA2BE;EACC,iBAAA;AAzBH;;AA6BA;EACC;IAEC,0CAAA;IACA,UAAA;EA3BA;EA6BD;IACC,0CAAA;IACA,YAAA;EA3BA;AACF;AA6BA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AA3BD;AA4BC;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA1BF;AA2BE;EACC,YAAA;EACA,aAAA;AAzBH;AA2BE;;;EAGC,iCAAA;EACA,aAAA;AAzBH;AA2BE;EACC,oBAAA;EACA,YAAA;AAzBH;AA2BE;;EAEC,oCAAA;AAzBH;AA2BE;EACC,eAAA;AAzBH;AA2BE;EACC,eAAA;AAzBH;AA2BE;EACC,eAAA;EACA,yBAAA;EACA,kBAAA;AAzBH;AA4BC;EACC,eAAA;EAEA,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AA3BF;AA4BE;EACC,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,oCAAA;EACA,iCAAA;AA1BH;AA4BE;EACC,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,oCAAA;EACA,iCAAA;AA1BH;AA4BE;EACC,iBAAA;EACA,iBAAA;EACA,UAAA;EACA,UAAA;AA1BH;;AA+BA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;AA5BD;;AA+BA;EACC,uBAAA;EACA,YAAA;AA5BD;;AA+BA;EACC,YAAA;AA5BD;;AA+BA;EACC,gBAAA;AA5BD;AA8BC;EACC,UAAA;EACA,cAAA;EACA,qBAAA;EAEA,4BAAA;AA7BF","sourcesContent":["@import '../../../theme/mixins';\n\nion-header {\n\tbox-shadow: none;\n\n\t.main-header {\n\t\tposition: relative;\n\t\theight: 70px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 28px;\n\t\tborder-bottom: 0.5px solid #a3a3a3;\n\n\t\t.logo {\n\t\t\theight: 70px;\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\ttransform: translate(-50%, -50%);\n\t\t}\n\n\t\t.main-right {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tgap: 10px;\n\t\t\tmargin-left: auto;\n\n\t\t\t.order-chip {\n\t\t\t\tdisplay: none;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\theight: 30px;\n\t\t\t\tmargin-right: 12px;\n\t\t\t\tmargin-left: 10px;\n\t\t\t\tposition: relative;\n\n\t\t\t\t@include desktop {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t}\n\n\t\t\t\t&__busket {\n\t\t\t\t\theight: 100%;\n\n\t\t\t\t\t--icon-color: #1e1e1c;\n\t\t\t\t\theight: 30px;\n\t\t\t\t\twidth: 30px;\n\t\t\t\t\t// @include desktop {\n\t\t\t\t\t// \tpointer-events:  none;\n\t\t\t\t\t// }\n\t\t\t\t}\n\n\t\t\t\t&__quantity {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: -8px;\n\t\t\t\t\tright: -2px;\n\t\t\t\t\theight: 20px;\n\t\t\t\t\twidth: 20px;\n\t\t\t\t\tborder-radius: 50px;\n\t\t\t\t\tbackground-color: #ea4949;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\n\t\t\t\t\t.number {\n\t\t\t\t\t\tfont-family: AppFontSemiBold;\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.container-all {\n\t.wrapper-left {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-self: center;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\toverflow: auto;\n\t\tbackground: #faf7f6;\n\t\tion-img {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t\t// background: url('') no-repeat center center / 105% 105%;\n\t\t// background-size: cover;\n\t\t// background-position: center;\n\t}\n\t&.wrapper-info {\n\t\toverflow: auto;\n\t\tpadding: 20px;\n\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tflex-direction: column;\n\t\t.header-title {\n\t\t\tmargin-top: 50px;\n\t\t\ttext-align: center;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\ttext-transform: capitalize;\n\t\t}\n\t\t.title-section {\n\t\t\twidth: 100%;\n\t\t\th3 {\n\t\t\t\ttext-align: center;\n\t\t\t\tcolor: var(--color-black);\n\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tfont-size: 18px;\n\t\t\t}\n\t\t}\n\t\tion-card {\n\t\t\tmargin: 20px 0px;\n\t\t\tpadding: 12px;\n\n\t\t\ttext-align: initial;\n\t\t\tborder: none;\n\t\t\tbox-shadow: none;\n\t\t\tbackground: transparent;\n\t\t\t--color: var(--color-black);\n\t\t\t--preorder-type-chip-border-color: var(--ion-color-primary);\n\t\t\toverflow: auto;\n\t\t\tword-break: break-word;\n\t\t\tion-card-header {\n\t\t\t\tbackground: white;\n\t\t\t\tcolor: var(--color-black);\n\t\t\t\tpadding: 0;\n\t\t\t\tpadding-bottom: 8px;\n\t\t\t\t.separator {\n\t\t\t\t\tmargin-block: 20px;\n\t\t\t\t}\n\t\t\t\tborder-bottom: 0.3px solid #7ea76973;\n\t\t\t}\n\t\t\tion-card-content {\n\t\t\t\tborder-top: 0.3px solid #7ea76973;\n\n\t\t\t\tpadding: 10px 0px 0px 0px;\n\t\t\t\tline-break: auto !important;\n\t\t\t\t&:first-of-type {\n\t\t\t\t\tborder: none;\n\t\t\t\t}\n\t\t\t\t.padding-card {\n\t\t\t\t\tpadding: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t\tion-card-title {\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tcolor: var(--color-black);\n\t\t\t\tfont-size: 18px;\n\t\t\t}\n\t\t\t.icon-edit {\n\t\t\t\tzoom: 1.3;\n\t\t\t}\n\t\t\tion-col {\n\t\t\t\tpadding: 5px 0px;\n\t\t\t\tcolor: var(--color-black);\n\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\t\t\t.left-col {\n\t\t\t\ttext-align: left;\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t}\n\n\t\t\t.right-col {\n\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\ttext-align: right;\n\t\t\t\t&.bold {\n\t\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.quantity {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\theight: 24px;\n\twidth: 24px;\n\tborder: 0.5px solid #262626;\n\tborder-radius: 50px;\n\tmargin-right: 10px;\n\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tline-height: 100%;\n\tletter-spacing: 0;\n\ttext-align: center;\n\tvertical-align: baseline;\n}\n\n.price-subtitle {\n\tion-col {\n\t\tfont-family: AppFont !important;\n\t}\n}\n\n.header-sliders {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: 20px 0px;\n\t.step {\n\t\twidth: 33%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\t.line {\n\t\t\twidth: 100%;\n\t\t\theight: 5px;\n\t\t\tbackground-color: #d9d9d9;\n\t\t\t&.selected {\n\t\t\t\tbackground-color: var(--ion-color-primary);\n\n\t\t\t\tanimation: pulse 2s infinite;\n\t\t\t}\n\t\t}\n\t\tp {\n\t\t\tpadding-top: 10px;\n\t\t}\n\t}\n}\n@keyframes pulse {\n\t0%,\n\t100% {\n\t\tbackground-color: var(--ion-color-primary);\n\t\topacity: 1;\n\t}\n\t50% {\n\t\tbackground-color: var(--ion-color-primary);\n\t\topacity: 0.5;\n\t}\n}\n.delivery-steps {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\t&__item {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tposition: relative;\n\t\tion-icon {\n\t\t\twidth: 100px;\n\t\t\theight: 100px;\n\t\t}\n\t\tp,\n\t\th3,\n\t\th5 {\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t\tpadding: 10px;\n\t\t}\n\t\tp {\n\t\t\tfont-family: AppFont;\n\t\t\tpadding: 0px;\n\t\t}\n\t\th3,\n\t\th5 {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t}\n\t\tp {\n\t\t\tfont-size: 12px;\n\t\t}\n\t\th5 {\n\t\t\tfont-size: 16px;\n\t\t}\n\t\th3 {\n\t\t\tfont-size: 18px;\n\t\t\ttext-transform: uppercase;\n\t\t\ttext-align: center;\n\t\t}\n\t}\n\t.map-block {\n\t\tmin-height: 0px;\n\n\t\topacity: 0;\n\t\tz-index: -1;\n\t\tmax-height: 0px;\n\t\tposition: relative;\n\t\t.show-time {\n\t\t\tposition: absolute;\n\t\t\ttop: 50px;\n\t\t\tbackground: white;\n\t\t\tpadding: 10px 20px;\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t\tz-index: 999;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t\t.status-show {\n\t\t\tposition: absolute;\n\t\t\tbottom: 50px;\n\t\t\tbackground: white;\n\t\t\tpadding: 10px 20px;\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t\tz-index: 999;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t\t&.hide-item {\n\t\t\tmin-height: 400px;\n\t\t\tmax-height: 400px;\n\t\t\topacity: 1;\n\t\t\tz-index: 1;\n\t\t}\n\t}\n}\n\n.map-container {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tmargin: 30px;\n\toverflow: hidden;\n}\n\n.map-frame {\n\tborder: 2px solid black;\n\theight: 100%;\n}\n\n#map-item {\n\theight: 100%;\n}\n\nion-footer {\n\tbox-shadow: none;\n\n\tion-button {\n\t\twidth: 80%;\n\t\tmargin: 0 auto;\n\t\t--border-radius: 50px;\n\n\t\tfont-family: AppFontSemiBold;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
